module.exports = __webpack_public_path__ + "img/Transaction.6ee675d0.png";